<template>
  <div v-if="tradeApplyOrderVO.applyType === '02'">
    <div class="trade-order-block">
      <div class="block-title">订单执行信息</div>
      <div class="block-title block-sub-title">批量化物料</div>
      <div class="block-content">
        <el-row class="content-row">
          <el-col :span="3">活动主题</el-col>
          <el-col :span="9">{{ tradeApplyInfoVO.eventSubject }}</el-col>
          <el-col :span="3">预计门店数量</el-col>
          <el-col :span="9">{{ tradeApplyInfoVO.estimatePocQty | thousandSymbol }}</el-col>
        </el-row>
        <el-row class="content-row">
          <el-col :span="3">业务线</el-col>
          <el-col :span="9">
            {{
           tradeApplyInfoVO.clientTypeName
            }}
          </el-col>
          <el-col :span="3">渠道</el-col>
          <el-col :span="9">{{ tradeApplyInfoVO.channelName }}</el-col>
        </el-row>
        <el-row class="content-row">
          <el-col :span="3">需求交货日期</el-col>
          <el-col :span="9">
            {{
            tradeApplyInfoVO.deliveryDate | parseTime("{y}-{m}-{d} {h}:{i}")
            }}
          </el-col>
          <el-col :span="3">申报说明</el-col>
          <el-col :span="9" style="word-break: break-all">
            {{
            tradeApplyInfoVO.applyDesc
            }}
          </el-col>
        </el-row>
        <el-row class="content-row">
          <el-col :span="3">示例图片</el-col>
          <el-col :span="21" class="info-img">
            <div
              v-if="
              tradeApplyInfoVO.tradeBmApplyImageList &&
              tradeApplyInfoVO.tradeBmApplyImageList.length
            "
            >
              <div class="img-wrapper" v-for="img in tradeApplyExecCustom.tradeApplyExecCustomList" :key="img.imageId">
                <el-image
                  :src="getImg(img.imageUri)"
                  :preview-src-list="getPreviewImageList(tradeApplyExecCustom.tradeApplyExecCustomList)"
                  fit="cover"
                  class="img-wrapper__item"
                />
                <div class="img-wrapper-title">{{ img.imageName }}</div>
              </div>
            </div>
            <div v-else>暂无</div>
          </el-col>
        </el-row>
        <el-row class="content-row">
          <el-table
            :data="tradeBmApplyDetailList"
            border
            :header-cell-style="{
              color: 'rgba(13, 13, 13, 85)',
              'text-align': 'center',
            }"
          >
            <el-table-column property="itemName" label="物料名称" align="center"></el-table-column>
            <el-table-column property="itemQty" label="物料数量" align="center"></el-table-column>
            <el-table-column align="center" property="brandName,subBrandName" label="品牌">
              <template slot-scope="scope">
                <div>
                  {{ scope.row.brandName }}-{{
                  scope.row.subBrandName
                  }}
                </div>
              </template>
            </el-table-column>
          </el-table>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import { commonUtils } from '@/utils/common'

export default {
  name: 'store-bulk-info',
  data () {
    return {
      tradeApplyOrderVO: '',
      tradeApplyInfoVO: '',
      tradeBmApplyDetailList: [],
      tradeBmApplyImageList: []
    }
  },
  created () { },
  methods: {
    setBulkInfo (val) {
      this.tradeApplyOrderVO = val
      this.tradeApplyInfoVO = val.tradeApplyInfoVO
      this.tradeBmApplyDetailList = val.tradeBmApplyDetailList
      this.tradeBmApplyImageList = val.tradeBmApplyImageList || []
    },

    getImg (uri) {
      return commonUtils.getImageUrl(uri)
    },

    setClientType (val) {
      if (val === '01') return 'TMKT'
      if (val === '02') return 'ISP'
      if (val === '03') return 'KA'
      return ''
    },

    getPreviewImageList (list) {
      if (list && list.length) {
        return list.map(item => {
          return this.getImg(item.imageUri)
        })
      }
      return []
    }
  }
}
</script>

<style lang="scss" scoped>
.bulk-list-title {
  color: #333;
}

.bulk-list {
  margin-top: 8px;
}

.bulk-list-content {
  color: #333;
  font-size: 13px;
}

.bulk-img {
  display: flex;

  div {
    width: 150px;
    height: 110px;
    margin-right: $content-middle;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      cursor: pointer;
      border-radius: 8px;
    }
  }
}
</style>
